<template>
  <div id="main-content">
    <div class="wrapper">
      <div class="table-agile-info">
        <jm-crumbs/>
        <jm-toolbar customize-field-name="">
        </jm-toolbar>
        <el-form
          :inline="true"
          :model="searchData">
          <el-form-item>
            <el-radio
              :disabled="!editButton"
              v-for="item in dict.country"
              :key="item.id"
              v-model="searchData.country_id"
              :label="item.id"
              @change="reLoad()"
            >{{ item.value }}</el-radio>
          </el-form-item>
        </el-form>
        <el-row class="th">
          <el-col :span="6">姓名</el-col>
          <el-col :span="6">分配几率</el-col>
          <el-col v-if="$hasPermission([1])" :span="6">分配人数(超管)</el-col>
          <el-col :span="6">能办理的国家</el-col>
        </el-row>
        <el-row class="th-row" v-for="(item, i) in info" :key="i">
          <el-col :span="6"><span v-if="item.testkey === 1" class="red">【测】</span> {{ item.truename }}</el-col>
          <el-col :span="6"><el-input class="jm-input135" v-model="item.alloc_p" @blur="getSum()"/>%</el-col>
          <el-col v-if="$hasPermission([1])" :span="6"><span>{{ item.alloc_value }}</span></el-col>
          <el-col :span="6"><span>{{ item.countries_text }}</span></el-col>
        </el-row>
        <el-row>
          <el-col class="fr" :span="6">总计：</el-col>
          <el-col :span="6"><el-input class="jm-input135" v-model="sum"/>%</el-col>
          <el-col :span="6"><el-button v-if="editButton" type="primary" @click="edit()">保存</el-button></el-col>
          <el-col :span="6">&nbsp;</el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .red {
    color: red;
  }
  .el-form-item {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-row.th {
    font-weight: 6;
    background-color: #01142d;
    color: #fff;
    text-align: center;
  }
  .el-row {
    line-height: 40px;
  }
  .th-row:nth-child(even){
    background-color: #e2eaf0;
  }

</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      refresh: false,
      searchData: { country_id: 0 },
      info: [],
      dict: {
        country: [],
        groups: []
      },
      editButton: true,
      sum: 0
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
  },
  computed: {},
  methods: {
    dictCountry() {
      return this.dict.country;
    },
    edit() { // 编辑
      this.editButton = false;
      this.$http._post({
        url: 'index/Teacher/editTeacherAllocation',
        data: this.info,
      }).then((res) => {
        if (res.result === 0) {
          this.$message({
            type: 'success',
            message: '保存成功!'
          });
          this.editButton = true;
          this.reLoad();
        }
      });
    },
    reLoad() {
      this.editButton = false;
      this.$http._post({
        url: 'index/Teacher/getTeacherAllocationInfo',
        data: this.searchData,
      }).then(({ data }) => {
        this.editButton = true;
        this.info = data;
        this.getSum();
      });
    },
    getSum() {
      let ln = this.info.length;
      let sum = 0;
      if (ln) {
        for (let i = 0; i < ln; i++) {
          sum += parseFloat(this.info[i].alloc_p);
        }
      }
      console.log(this.info, sum);
      this.sum = sum;
    }
  },
  created() {
    this.$http._post({
      url: 'index/Teacher/getDic',
    }).then(({ data }) => {
      // 若指定 countryIds 则只展示
      if (this.$route.meta.countryIds && this.$route.meta.countryIds.length > 0) {
        let countryIds = this.$route.meta.countryIds;
        data.country = data.country.filter((item) => {
          return countryIds.indexOf(item.id) > -1;
        });
      }

      this.dict = data;
      this.searchData.country_id = this.dict.country[0].id;
      this.reLoad();
    });
  }
};
</script>
